// extracted by mini-css-extract-plugin
module.exports = {"Support":"C_Support__pGqx4"};